/**
 * #902: whose data a family turn opens on a member's own screen (Today, Wallet). `undefined` with no
 * turn: the screen asks verify, as for an ordinary sign-in. Otherwise `key` names this turn, member and
 * generation, so the same child picked again is a new key, and `member` is the turn's live member in
 * the screen's own fields (`project(member, familyTurn)`), or `null` when it has none: locked, revoked
 * or unreadable. Never the account.
 *
 * @param {object|null|undefined} familyTurn  the actor context's `familyTurn` (`api/session.js` `toFamilyTurn`)
 * @param {(member: object, familyTurn: object) => object} project
 * @returns {{ key: string, member: object|null }|undefined}
 */
export function turnSubject(familyTurn, project) {
  if (!familyTurn) return undefined;
  const member = familyTurn.state === 'active' ? familyTurn.member : null;
  if (!member || member.userId === undefined || member.userId === null) return { key: 'nobody', member: null };
  return { key: `${member.userId}:${familyTurn.generation}`, member: project(member, familyTurn) };
}
